<template>
  <v-form v-model="valid" ref="mainForm">
    <subheadline code="titre-etape-2.1"></subheadline>

    <opq-catalogue code="limites" v-model="sasInspection1.tiensCompteDesLimites" :live="liveSasInspection1(12315)"></opq-catalogue>

    <opq-catalogue code="respect" v-model="sasInspection1.adopteAttitudeRespecteuse" :live="liveSasInspection1(12316)"></opq-catalogue>

    <opq-catalogue
      code="secret-professionnel"
      v-model="sasInspection1.respecteSecretProEtReglesConfidentialite"
      :live="liveSasInspection1(12317)"
    ></opq-catalogue>

    <opq-catalogue code="renseignements" v-model="sasInspection1.transmetsRenseignementsJustes" :live="liveSasInspection1(12318)"></opq-catalogue>

    <opq-memo code="renseignements_details" v-model="sasInspection1.renseignementsDetails" :live="liveSasInspection1(12319)"></opq-memo>

    <opq-catalogue code="consentement" v-model="sasInspection1.appliqueReglesConsentement" :live="liveSasInspection1(12320)"></opq-catalogue>

    <opq-memo code="consentement_details" v-model="sasInspection1.consentementDetails" :live="liveSasInspection1(12321)"></opq-memo>

    <opq-catalogue code="integrite" v-model="sasInspection1.respectePrincipesDIntegrite" :live="liveSasInspection1(12322)"></opq-catalogue>

    <opq-catalogue
      code="pratique-professionnelle"
      v-model="sasInspection1.fondePratiqueProfessionnellePrincipesScientifiquesEtProfessionnels"
      :live="liveSasInspection1(12323)"
    ></opq-catalogue>

    <opq-catalogue
      code="equilibre-travail-vie"
      v-model="sasInspection1.equilibreTravailViePersonnelle"
      :live="liveSasInspection1(12324)"
    ></opq-catalogue>

    <opq-catalogue code="conflit-interets" v-model="sasInspection1.attentionConflitDInterets" :live="liveSasInspection1(12325)"></opq-catalogue>

    <opq-memo code="conflit-interets-details" v-model="sasInspection1.conflitDInteretsDetails" :live="liveSasInspection1(12326)"></opq-memo>

    <opq-catalogue code="promotion-sante" v-model="sasInspection1.principesPromotionSante" :live="liveSasInspection1(12327)"></opq-catalogue>

    <opq-catalogue code="respect-lois" v-model="sasInspection1.respecteLoisEtReglements" :live="liveSasInspection1(12328)"></opq-catalogue>

    <opq-catalogue code="honoraires-justes" v-model="sasInspection1.honorairesJustesEtRaisonnables" :live="liveSasInspection1(12329)"></opq-catalogue>

    <opq-catalogue code="recus-conformes" v-model="sasInspection1.recusConformes" :live="liveSasInspection1(12330)"></opq-catalogue>

    <opq-catalogue code="cours-deontologie" v-model="sasInspection1.coursDeontologie" :live="liveSasInspection1(12331)"></opq-catalogue>

    <opq-date-picker
      :opq-if="estCoursDeontologie"
      code="cours-deontologie-date"
      v-model="sasInspection1.dateCoursDeontologie"
      :live="liveSasInspection1(12332)"
    ></opq-date-picker>

    <opq-memo code="deontologie-exemple" v-model="sasInspection1.deontologieExemple" :live="liveSasInspection1(12333)"></opq-memo>

    <opq-memo code="deontologie-details" v-model="sasInspection1.deontologieDetails" :live="liveSasInspection1(12334)"></opq-memo>

    <subheadline code="titre-etape-2.2"></subheadline>

    <opq-catalogue code="approche-client" v-model="sasInspection1.approcheClient" :live="liveSasInspection1(12336)"></opq-catalogue>

    <opq-catalogue code="empathie" v-model="sasInspection1.empathieEtRespect" :live="liveSasInspection1(12337)"></opq-catalogue>

    <opq-catalogue code="presence-attentive" v-model="sasInspection1.presenceAttentiveEtSensible" :live="liveSasInspection1(12338)"></opq-catalogue>

    <opq-catalogue code="dignite" v-model="sasInspection1.respectDigniteAutonomie" :live="liveSasInspection1(12339)"></opq-catalogue>

    <opq-catalogue code="preoccupations" v-model="sasInspection1.preoccupationsEtAttentes" :live="liveSasInspection1(12340)"></opq-catalogue>

    <opq-catalogue code="caracteristiques-client" v-model="sasInspection1.caracteristiquesClients" :live="liveSasInspection1(12341)"></opq-catalogue>

    <opq-catalogue
      code="strategie-communication"
      v-model="sasInspection1.adapteStrategieCommunication"
      :live="liveSasInspection1(12342)"
    ></opq-catalogue>

    <opq-catalogue code="soutien-efficace" v-model="sasInspection1.apporteSoutienEfficace" :live="liveSasInspection1(12343)"></opq-catalogue>

    <opq-catalogue code="autonomisation" v-model="sasInspection1.soutienAutonomisation" :live="liveSasInspection1(12344)"></opq-catalogue>

    <opq-catalogue code="distance-professionnelle" v-model="sasInspection1.distanceProfessionnelle" :live="liveSasInspection1(12345)"></opq-catalogue>

    <opq-memo code="clienteles-defi" v-model="sasInspection1.clientelesDefi" :live="liveSasInspection1(12346)"></opq-memo>

    <opq-memo code="clienteles-defi-moyens" v-model="sasInspection1.clientelesDefiMoyens" :live="liveSasInspection1(12347)"></opq-memo>

    <subheadline code="titre-etape-2.3"></subheadline>

    <opq-catalogue code="roles-responsabilites" v-model="sasInspection2.rolesEtResponsabilites" :live="liveSasInspection2(12403)"></opq-catalogue>

    <opq-catalogue code="apport-psy" v-model="sasInspection2.apportPsy" :live="liveSasInspection2(12404)"></opq-catalogue>

    <opq-catalogue code="information-utile" v-model="sasInspection2.informationUtile" :live="liveSasInspection2(12405)"></opq-catalogue>

    <opq-catalogue code="information-transmise" v-model="sasInspection2.informationTransmise" :live="liveSasInspection2(12406)"></opq-catalogue>

    <opq-catalogue code="information-recue" v-model="sasInspection2.informationRecue" :live="liveSasInspection2(12407)"></opq-catalogue>

    <opq-catalogue
      code="planification-services-offerts"
      v-model="sasInspection2.planificationServicesOfferts"
      :live="liveSasInspection2(12408)"
    ></opq-catalogue>

    <opq-catalogue
      code="amelioration-services-offerts"
      v-model="sasInspection2.ameliorationServicesOfferts"
      :live="liveSasInspection2(12409)"
    ></opq-catalogue>

    <opq-catalogue code="discussion-pairs" v-model="sasInspection2.discussionPairs" :live="liveSasInspection2(12410)"></opq-catalogue>

    <opq-catalogue code="ouverture-suggestions" v-model="sasInspection2.ouvertureSuggestions" :live="liveSasInspection2(12411)"></opq-catalogue>

    <opq-memo code="engagement-details" v-model="sasInspection2.engagementDetails" :live="liveSasInspection2(12412)"></opq-memo>

    <subheadline code="titre-etape-2.4"></subheadline>

    <opq-catalogue code="dossier-client" v-model="sasInspection2.dossierClient" :live="liveSasInspection2(12413)"></opq-catalogue>

    <opq-catalogue code="dossier-conservation" v-model="sasInspection2.dossierConservation" :live="liveSasInspection2(12414)"></opq-catalogue>

    <opq-catalogue code="dossier-confidentialite" v-model="sasInspection2.dossierConfidentialite" :live="liveSasInspection2(12415)"></opq-catalogue>

    <opq-catalogue code="dossier-date" v-model="sasInspection2.dossierInscriptionDate" :live="liveSasInspection2(12416)"></opq-catalogue>

    <opq-catalogue code="donnees-nominatives" v-model="sasInspection2.donneesNominatives" :live="liveSasInspection2(12417)"></opq-catalogue>

    <opq-catalogue code="description-motifs" v-model="sasInspection2.descriptionMotifs" :live="liveSasInspection2(12418)"></opq-catalogue>

    <opq-catalogue
      code="conclusions-evaluation-initiale"
      v-model="sasInspection2.conclusionsEvaluationInitiale"
      :live="liveSasInspection2(12419)"
    ></opq-catalogue>

    <opq-catalogue code="notations-evolution" v-model="sasInspection2.notationsEvolution" :live="liveSasInspection2(12420)"></opq-catalogue>

    <opq-catalogue code="document-transmission" v-model="sasInspection2.documentTransmission" :live="liveSasInspection2(12421)"></opq-catalogue>

    <opq-catalogue code="copie-contrat" v-model="sasInspection2.copieContrat" :live="liveSasInspection2(12422)"></opq-catalogue>

    <opq-catalogue code="signature-information" v-model="sasInspection2.signatureInformation" :live="liveSasInspection2(12423)"></opq-catalogue>

    <opq-catalogue code="dossier-unique" v-model="sasInspection2.dossierUnique" :live="liveSasInspection2(12424)"></opq-catalogue>

    <opq-catalogue code="donnee-brute" v-model="sasInspection2.donneeBrute" :live="liveSasInspection2(12425)"></opq-catalogue>

    <opq-catalogue
      code="dossier-conservation-lieusur"
      v-model="sasInspection2.dossierConservationLieuSur"
      :live="liveSasInspection2(12426)"
    ></opq-catalogue>

    <opq-catalogue code="membre-lssss" v-model="sasInspection2.membreLssss" :live="liveSasInspection2(12455)"></opq-catalogue>

    <opq-catalogue
      :opq-if="estNonMembreLssss"
      code="dossier-conservation-5ans"
      v-model="sasInspection2.dossierConservation5ans"
      :live="liveSasInspection2(12428)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estNonMembreLssss"
      code="dossier-destruction"
      v-model="sasInspection2.dossierDestruction"
      :live="liveSasInspection2(12429)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estNonMembreLssss"
      code="dossier-transmission-delai"
      v-model="sasInspection2.dossierTransmissionDelai"
      :live="liveSasInspection2(12430)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estNonMembreLssss"
      code="dossier-transmission-formulaire"
      v-model="sasInspection2.dossierTransmissionFormulaire"
      :live="liveSasInspection2(12431)"
    ></opq-catalogue>

    <opq-catalogue code="dossier-exercice-societe" v-model="sasInspection2.dossierExerciceSociete" :live="liveSasInspection2(12433)"></opq-catalogue>

    <opq-catalogue
      code="transmission-donnees-brutes"
      v-model="sasInspection2.transmissionDonneesBrutes"
      :live="liveSasInspection2(12434)"
    ></opq-catalogue>

    <opq-catalogue code="formation-tenue-dossiers" v-model="sasInspection2.formationTenueDossiers" :live="liveSasInspection2(12435)"></opq-catalogue>

    <opq-date-picker
      :opq-if="estFormationTenueDossiers"
      code="formation-tenue-dossiers-date"
      v-model="sasInspection2.dateFormationTenueDossiers"
      :live="liveSasInspection2(12436)"
    ></opq-date-picker>

    <div class="mb-3">
      <ressource code="desc-redaction-rapports"></ressource>
    </div>

    <opq-catalogue code="mandat-evaluation" v-model="sasInspection2.mandatEvaluation" :live="liveSasInspection2(12437)"></opq-catalogue>

    <opq-catalogue code="methodologie-evaluation" v-model="sasInspection2.methodologieEvaluation" :live="liveSasInspection2(12438)"></opq-catalogue>

    <opq-catalogue code="conclusions-evaluation" v-model="sasInspection2.conclusionsEvaluation" :live="liveSasInspection2(12439)"></opq-catalogue>

    <opq-catalogue code="guide-bonnes-pratiques" v-model="sasInspection2.guideBonnesPratiques" :live="liveSasInspection2(12440)"></opq-catalogue>

    <opq-catalogue
      code="date-rapport-evaluation"
      v-model="sasInspection2.rapportEvaluationInscriptionDate"
      :live="liveSasInspection2(12441)"
    ></opq-catalogue>

    <opq-memo code="delai-rapports" v-model="sasInspection2.delaiRapports" :live="liveSasInspection2(12442)"></opq-memo>

    <subheadline code="titre-etape-2.5"></subheadline>

    <opq-catalogue code="cabinet-consultation" v-model="sasInspection2.cabinetConsultation" :live="liveSasInspection2(12444)"></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-professionnel"
      v-model="sasInspection2.cabinetProfessionnel"
      :live="liveSasInspection2(12445)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-confidentiel"
      v-model="sasInspection2.cabinetConfidentiel"
      :live="liveSasInspection2(12446)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-salle-attente"
      v-model="sasInspection2.cabinetSalleDAttente"
      :live="liveSasInspection2(12447)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-conforme"
      v-model="sasInspection2.cabinetConforme"
      :live="liveSasInspection2(12448)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-permis-affiche"
      v-model="sasInspection2.cabinetPermisAffiche"
      :live="liveSasInspection2(12449)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-documents-originaux"
      v-model="sasInspection2.cabinetDocumentsOriginaux"
      :live="liveSasInspection2(12450)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-diplome-affiche"
      v-model="sasInspection2.cabinetDiplomeAffiche"
      :live="liveSasInspection2(12451)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-absence"
      v-model="sasInspection2.cabinetAbsence"
      :live="liveSasInspection2(12452)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estCabinetConsultation"
      code="cabinet-avis-ordre"
      v-model="sasInspection2.cabinetAvisOrdre"
      :live="liveSasInspection2(12453)"
    ></opq-catalogue>

    <opq-memo
      :opq-if="estCabinetConsultation"
      code="cabinet-avis-ordre-commentaire"
      v-model="sasInspection2.cabinetAvisOrdreCommentaire"
      :live="liveSasInspection2(12454)"
      optional
    ></opq-memo>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasInspection1() {
      return this.sas.sasInspection1
    },

    sasInspection2() {
      return this.sas.sasInspection2
    },

    estCoursDeontologie() {
      return this.estOui(this.sasInspection1.coursDeontologie)
    },

    estNonMembreLssss() {
      return this.estNon(this.sasInspection2.membreLssss)
    },

    estFormationTenueDossiers() {
      return this.estOui(this.sasInspection2.formationTenueDossiers)
    },

    estCabinetConsultation() {
      return this.estOui(this.sasInspection2.cabinetConsultation)
    }
  },

  methods: {
    liveSasInspection1(cle) {
      return { endpoint: "/sas-inspection-1/", cle: cle, fileId: this.sasInspection1.id }
    },

    liveSasInspection2(cle) {
      return { endpoint: "/sas-inspection-2/", cle: cle, fileId: this.sasInspection2.id }
    }
  }
}
</script>

<style>
</style>